import { Check, CalendarCheck, ArrowRight } from "lucide-react";
import { SEO } from "@/components/site/SEO";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";

const VIDEO_ID = "IZ6MiMNZ5aM";
const BOOKING_URL = "https://calendly.com/shawnksfg/new-meeting";

const Step = ({ n, title, children }) => (
  <div className="flex gap-4">
    <span className="shrink-0 inline-flex h-9 w-9 items-center justify-center rounded-full bg-gold/20 text-bronze font-serif text-lg">{n}</span>
    <div className="flex-1">
      <h2 className="font-serif text-xl text-legacy leading-tight">{title}</h2>
      <div className="mt-2 text-slate text-[0.95rem] leading-relaxed">{children}</div>
    </div>
  </div>
);

export default function SaveSpendSystemAccess() {
  return (
    <div className="min-h-screen bg-ivory" data-testid="save-spend-system-access-page">
      <SEO title="Save & Spend System Overview \u2014 Access | Legacy Life & Retirement" noindex />
      <Header />
      <main className="relative bg-ivory pt-[120px] md:pt-[150px] pb-24 md:pb-28 overflow-hidden">
        <div className="pointer-events-none absolute inset-0 grid-lines opacity-40" />
        <div className="container-lr relative max-w-3xl">
          <span className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-gold text-legacy"><Check size={26} /></span>
          <p className="eyebrow mt-6">Request Confirmed</p>
          <h1 className="mt-3 font-serif font-semibold tracking-display text-legacy text-3xl md:text-4xl leading-[1.08]">
            Your Save & Spend System Overview Is Ready
          </h1>
          <p className="mt-5 text-slate text-base md:text-lg leading-relaxed">
            Watch the full overview below to see how the Save & Spend System helps families organize cash flow, maintain access to their money, and begin building their own family banking system.
          </p>

          <div className="mt-10 space-y-10">
            {/* Section 1 */}
            <Step n="1" title="Watch the Save & Spend System Overview">
              <div className="mt-4 aspect-video w-full rounded-card overflow-hidden bg-black border border-taupe/40">
                <iframe className="h-full w-full" src={`https://www.youtube-nocookie.com/embed/${VIDEO_ID}?rel=0`}
                  title="Save & Spend System Overview" loading="lazy" allowFullScreen
                  allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  data-testid="save-spend-access-video" />
              </div>
            </Step>

            {/* Section 2 */}
            <Step n="2" title="Ready to Build Your Own System?">
              Book a free strategy call to discuss how the Save &amp; Spend System could fit into your cash flow, financial goals, and long-term strategy.
              <div className="mt-4 flex flex-wrap items-center gap-4">
                <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer"
                  data-testid="save-spend-access-book-call" className="btn-base btn-primary text-[0.82rem] tracking-[0.1em] uppercase">
                  <CalendarCheck size={16} />Book Your Free Strategy Call
                </a>
                <a href="/resources"
                  data-testid="save-spend-access-resources-link"
                  className="inline-flex items-center gap-1.5 text-bronze font-medium text-[0.9rem] hover:text-gold transition-colors">
                  Browse More Free Resources<ArrowRight size={16} />
                </a>
              </div>
            </Step>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
